// ToggleSwitch.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ToggleSwitch = ({ active, onToggle }) => (
  <SwitchWrapper onClick={() => onToggle()} active={active}>
    <Slider active={active} />
  </SwitchWrapper>
);

const SwitchWrapper = styled.div`
  position: relative;
  border: solid 1px ${({ active }) => (active ? '#00e6d2' : '#646464')};
  border-radius: 52px;
  height: 30px;
  width: 52px;
  background-color: ${({ active }) => (active ? '#00e6d2' : '#292929')};
  transition-duration: 0.3s;
  transition-property: background-color, border-color;
`;

const Slider = styled.div`
  position: absolute;
  top: 50%;
  left: ${({ active }) => (active ? 25 : 1)}px;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
  transform: translateY(-50%);
  transition-duration: 0.3s;
  transition-property: left;
`;

ToggleSwitch.propTypes = {
  active: PropTypes.bool,
  onToggle: PropTypes.func,
};

ToggleSwitch.defaultProps = {
  active: false,
  onToggle: () => null,
};

export default ToggleSwitch;
